import { authAction } from 'common/constants';

const initAuth = {
    token: '',
};

const authReducer = (state = initAuth, action) => {
    switch (action.type) {
        case authAction.SET_TOKEN:
            return {
                ...state,
                token: action.payload,
            };
        case authAction.DELETE_TOKEN:
            return {
                ...state,
                token: '',
            };

        case authAction.SET_ENABLE_FEATURES:
            return {
                ...state,
                enable_features: action.payload,
            };
        case authAction.DELETE_ENABLE_FEATURES:
            return {
                ...state,
                enable_features: [],
            };
        case authAction.GET_USER:
            return {
                ...state,
                user: action.payload,
            };
        default:
            return state;
    }
};

export default authReducer;
